import { Box } from "@mui/material";
import BrokenImageOutlinedIcon from "@mui/icons-material/BrokenImageOutlined";
import { useState } from "react";

interface Props {
  imageUrl: string;
  altText: string;
  size?: number | string;
  onClick?: () => void;
}

export const ImageThumbnail = ({ imageUrl, altText, size = 256, onClick }: Props) => {
  const [hasError, setHasError] = useState(false);
  const isNumericSize = typeof size === "number";

  return (
    <Box
      onClick={onClick}
      sx={{
        width: size,
        height: isNumericSize ? size : "auto",
        aspectRatio: isNumericSize ? undefined : "1 / 1",
        borderRadius: 1,
        overflow: "hidden",
        border: 1,
        borderColor: "grey.300",
        backgroundColor: "grey.100",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        cursor: onClick ? "pointer" : "default",
        flexShrink: 0,
      }}
    >
      {hasError ? (
        <BrokenImageOutlinedIcon sx={{ color: "grey.500", fontSize: isNumericSize ? size / 3 : 48 }} />
      ) : (
        <img
          src={imageUrl}
          alt={altText}
          onError={() => setHasError(true)}
          style={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
            display: "block",
          }}
        />
      )}
    </Box>
  );
};
